export default {
  // 基础信息
  basicInfo: {
    grade: [], // 年级
    term: [], // 学期
    version: [], // 版本
    difficulty: [], // 难度
    packageAttr: [], // 页面包属性
    years: [], // 学年
    plan: [] // 讲次
  },
  basicInfoBgList: {
    grade: [], // 年级
    term: [], // 学期
    version: [], // 版本
    difficulty: [], // 难度
    packageAttr: [], // 页面包属性
    years: [], // 学年
    plan: [] // 讲次
  },
  // 课件详情页面包数据
  packages: [],
  // 课件背景图
  backStatus: '',
  // 课件基础信息
  coursewareInfo: {
    create_id: '',
    create_name: '',
    create_time: '',
    difficulty_id: '',
    grade_digits: '',
    grade_ids: [],
    id: '',
    is_freeze: '',
    modify_id: '',
    modify_name: '',
    modify_time: '',
    name: '',
    status: '',
    term_digits: '',
    term_ids: [],
    version_id: '',
    packageInfo: []
  },
  filterData: {
    type: '1',
    status: null,
    gradeIds: null,
    termIds: null,
    versionId: null,
    difficultyId: null,
    yearId: null,
    searchType: null,
    keyword: null,
    curpage: 1,
    perpage: 20
  }
}



// WEBPACK FOOTER //
// ./src/store/courseware/state.js